import script from "./LossesOrGains.vue?vue&type=script&setup=true&lang=js"
export * from "./LossesOrGains.vue?vue&type=script&setup=true&lang=js"

import "./LossesOrGains.vue?vue&type=style&index=0&id=2e9b138d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e9b138d"]])

export default __exports__